const List = $(".js-list");

if ($('.js-list').length) {
	$(".js-item").hide();
	List.on("click", function () {
		var SubList = $(this).next('.p-faq__answerbox'),
				SubNotList = List.not($(this)).next('.p-faq__answerbox'),
				ListTtl = $(this);

		ListTtl.toggleClass('js-list--open');
		SubList.slideToggle();
		SubNotList.slideUp(function(){
			$(this).prev('.js-list--open').toggleClass('js-list--open');
		});
	});
}

if ($('.js-faq').length) {
	const Btn1 = $('.js-faq1'),
				Btn2 = $('.js-faq2'),
				Btn3 = $('.js-faq3'),
				Btn4 = $('.js-faq4'),
				Content1 =$('.js-faqbox1'),
				Content2 =$('.js-faqbox2'),
				Content3 =$('.js-faqbox3'),
				Content4 =$('.js-faqbox4');

	Btn1.on("click", function () {
		$(this).addClass("u-menuactive");
		Btn2.removeClass("u-menuactive");
		Btn3.removeClass("u-menuactive");
		Btn4.removeClass("u-menuactive");
		Content1.addClass("js-open");
		Content2.removeClass("js-open");
		Content3.removeClass("js-open");
		Content4.removeClass("js-open");
	});

	Btn2.on("click", function () {
		$(this).addClass("u-menuactive");
		Btn1.removeClass("u-menuactive");
		Btn3.removeClass("u-menuactive");
		Btn4.removeClass("u-menuactive");
		Content2.addClass("js-open");
		Content1.removeClass("js-open");
		Content3.removeClass("js-open");
		Content4.removeClass("js-open");
	});

	Btn3.on("click", function () {
		$(this).addClass("u-menuactive");
		Btn1.removeClass("u-menuactive");
		Btn2.removeClass("u-menuactive");
		Btn4.removeClass("u-menuactive");
		Content3.addClass("js-open");
		Content1.removeClass("js-open");
		Content2.removeClass("js-open");
		Content4.removeClass("js-open");
	});

	Btn4.on("click", function () {
		$(this).addClass("u-menuactive");
		Btn1.removeClass("u-menuactive");
		Btn2.removeClass("u-menuactive");
		Btn3.removeClass("u-menuactive");
		Content4.addClass("js-open");
		Content1.removeClass("js-open");
		Content2.removeClass("js-open");
		Content3.removeClass("js-open");
	});
}

if ($('.js-voice').length) {
  function Inner() {
    var inner = document.querySelector('.js-voice');
    var style = window.getComputedStyle(inner);
    var margin = style.getPropertyValue('margin-left');
    
    document.documentElement.style.setProperty('--margin', margin);

		marginLeftVal = parseInt( $(".js-voice").css('margin-left') );
		if( 60 < marginLeftVal){
			$(".p-voice__img").addClass("p-voice__img--fixed");
		}else{
			$(".p-voice__img").removeClass("p-voice__img--fixed");
		}
	}
  Inner();
  $(window).resize(Inner);
  $('body').addClass('p-voice-page');
};

if ($('.js-products').length) {
	function Slick() {
		var winW = $(window).width();

		if(winW <= 767){
			$('.js-products').not('.slick-initialized').slick({
				dots: false,
				arrows: true,   
				centerMode: true,
				centerPadding: '41px',
				infinite: false,
				slidesToShow: 1,
				variableWidth: true,
			});
		}else{
			$('.js-products.slick-initialized').slick('unslick');
		}
	}
  $(window).resize(function(){
		Slick();
	});
	Slick();
}

if ($('.js-mainbtn').length) {
	var BtnPos = $('.js-header').offset().top; 
	$(window).on('scroll', function() {
		if ($(this).scrollTop() > BtnPos ) {
			$('.js-mainbtn').addClass( 'js-fixed' );
		} else {
			$('.js-mainbtn').removeClass( 'js-fixed' );
		}
	});

	function Header() {
		var headH = $('.js-header').height();
		document.documentElement.style.setProperty('--headh', headH + "px");
	}
	Header();
	$(window).resize(Header);
}

if ($('.js-inner').length) {
	function Inner2() {
    var inner = document.querySelector('.js-inner');
    var style = window.getComputedStyle(inner);
    var margin = style.getPropertyValue('margin-left');
    
		if ($('.p-pabout__pos').length) {
			marginLeft = parseInt( $(".p-pabout__pos").css('margin-left') );
			if( 0 < marginLeft){
				$(".p-pabout__deco2img").addClass("js-left");
			}else{
				$(".p-pabout__deco2img").removeClass("js-left");
			}
		}
			
    document.documentElement.style.setProperty('--margin', margin);
	}
  Inner2();
  $(window).resize(Inner2);
}

if ($('.js-dev').length) {
	$(function(){
		const Dev= $('.js-dev'),
					DevCon = $('.js-devcon');
					
		Dev.on("click", function () {
			$(this).toggleClass('js-devbtn');
			DevCon.slideToggle(1000);
		});
	});
}

if ($('.p-subfoot__list').length) {
	function Foot() {
		var footH = $('.p-subfoot__list').height();
    document.documentElement.style.setProperty('--footh', footH + "px");
	}
  Foot();
  $(window).resize(Foot);
}

$('.js-sublayer--open').on("click", function () {
	$(this).toggleClass('is-open');
});



//お役立ち情報ブログ内ページトップボタンjs
   // ページトップjs スクロールした際の動きを関数でまとめる
      // 画面をスクロールをしたら動かしたい場合の記述
      $(window).scroll(function () {
        PageTopAnime(); // スクロールした際の動きの関数を呼ぶ
      });

      function PageTopAnime() {
        var scroll = $(window).scrollTop(); // スクロール値を取得
        var wH = window.innerHeight; // 画面の高さを取得
        var footer = $(".news-letter-page"); // footerの位置を取得
  var footerPos = footer.length ? footer.offset().top : 0;

        if (scroll >= 1000 && scroll <= footerPos - 900) {
          // 1000pxスクロールしたらaddClass
          $('.footerbtn_backto_top').addClass('is-fixed');
        } else {
          // それ以外は
          $('.footerbtn_backto_top').removeClass('is-fixed');
        }
      }

      // .footerbtn_backto_topをクリックした際の設定
      $('.footerbtn_backto_top').click(function () {
        $('body,html').animate(
          {
            scrollTop: 0, // ページトップまでスクロール
          },
          400
        ); // ページトップスクロールの速さ。数字が大きいほど遅くなる
        return false; // リンク自体の無効化
      });


// 商品ページカートボタンクリック時のポップアップjs
const clickBtn = document.getElementById('click-btn');
const popupWrapper = document.getElementById('popup-wrapper');
const close = document.getElementById('close');
// ボタンをクリックしたときにポップアップを表示させる
clickBtn.addEventListener('click', () => {
  popupWrapper.style.display = "block";
});
// ポップアップの外側又は「x」のマークをクリックしたときポップアップを閉じる
popupWrapper.addEventListener('click', e => {
  if (e.target.id === popupWrapper.id || e.target.id === close.id) {
    popupWrapper.style.display = 'none';
  }
});

// 商品ページ、カートへ追加スクロールボタンjs
  // ページトップjs スクロールした際の動きを関数でまとめる
  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    PageTopAnime2(); // スクロールした際の動きの関数を呼ぶ
  });

  function PageTopAnime2() {
    var scroll = $(window).scrollTop(); // スクロール値を取得
    var wH = window.innerHeight; // 画面の高さを取得
    var footer = $(".footer"); // footerの位置を取得
var footerPos = footer.length ? footer.offset().top : 0;

    if (scroll >= 1000 && scroll <= footerPos - 500) {
      // 1000pxスクロールしたらaddClass
      $('#product_fixbtm').addClass('active');
    } else {
      // それ以外は
      $('#product_fixbtm').removeClass('active');
    }
  }
